import { Grid, GridItem, Skeleton, Text, VStack } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

const CollectionsGridLoader = (): ReactElement | null => {
  const { t } = useTranslation()
  return (
    <VStack alignItems="flex-start" spacing={8}>
      <Text fontWeight="semibold" color="appSlate">
        {t('media_collections', 'Media collections')}
      </Text>
      <Grid
        gridTemplateColumns={[
          'repeat(1, minmax(4px, 1fr))',
          'repeat(2, minmax(4px, 1fr))',
          'repeat(3, minmax(4px, 1fr))',
          'repeat(5, minmax(4px, 1fr))',
        ]}
        columnGap={6}
        rowGap={6}
        width="100%"
      >
        {Array.from({ length: 5 }).map(() => (
          <GridItem>
            <Skeleton height="227px" borderRadius="lg" />
          </GridItem>
        ))}
      </Grid>
    </VStack>
  )
}

export default CollectionsGridLoader
